import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { changeLayout } from "slices/thunk";
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

const ROLE_DASHBOARDS: Record<string, string> = {
  adm: "/adashboard",
  cst: "/cdashboard",
  prt: "/",
  emp: "/",
  exp: "/edashboard",
};

const AuthProtected = (props: { children: React.ReactNode; allowedRoles?: string[] }) => {


  //////////////__________________ CODE FOR LAYOUT___________________ ////////////////// (please keep it here at top only)
  // import { changeLayout } from "slices/thunk";
  // import { LAYOUT_TYPES } from "Components/constants/layout";
  // import { useDispatch } from 'react-redux';



  const selectProperties = createSelector((state: any) => state.Layout, (layout) => ({ layoutType: layout.layoutTypes }));
  const { layoutType } = useSelector(selectProperties);
  const dispatch = useDispatch<any>();
  const location = useLocation();

  // Keep a ref so the popstate handler always has the current layoutType
  const layoutTypeRef = React.useRef(layoutType);
  useEffect(() => { layoutTypeRef.current = layoutType; }, [layoutType]);

  useEffect(() => {
    const currentPath = location.pathname;
    const isDomainRoute = /^\/\d+\/\d+(\/.*)?$/.test(currentPath);
    if (currentPath === '/' || currentPath === '' || currentPath === '/home' || currentPath === '/home/' || isDomainRoute) {
      if (layoutType === 'horizontal') { dispatch(changeLayout('vertical')); }
    } else {
      if (layoutType === 'vertical') { dispatch(changeLayout('horizontal')); }
    }
  }, [location.pathname, layoutType, dispatch]);

  useEffect(() => {
    const handlePopState = () => {
      const currentPath = window.location.pathname;
      const isDomainRoute = /^\/\d+\/\d+(\/.*)?$/.test(currentPath);
      const currentLayoutType = layoutTypeRef.current;
      if (currentPath === '/' || currentPath === '' || currentPath === '/home' || currentPath === '/home/' || isDomainRoute) {
        if (currentLayoutType === 'horizontal') { dispatch(changeLayout('vertical')); }
      } else {
        if (currentLayoutType === 'vertical') { dispatch(changeLayout('horizontal')); }
      }
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [dispatch]);
  //////////////_______________________________________________________///////////////////////

  if (!localStorage.getItem("authUser")) {
    return <Navigate to={{ pathname: "/login" }} />;
  }

  if (props.allowedRoles && props.allowedRoles.length > 0) {
    const userRole = localStorage.getItem("userole_") || "";
    if (!props.allowedRoles.includes(userRole)) {
      const redirectTo = ROLE_DASHBOARDS[userRole] || "/";
      return <Navigate to={{ pathname: redirectTo }} />;
    }
  }

  return (<React.Fragment>
    {props.children}
  </React.Fragment>);
};

export default AuthProtected;
